"use client";

import { useRouter } from "next/navigation";
import { Button } from "@/components/ui/button";
import { LogOut, User } from "lucide-react";
import { toast } from "react-toastify";
import { api } from "@/utils/api";

export default function Header() {
  const router = useRouter();

  const handleLogout = async () => {
    try {
      // Call the logout endpoint
      await api.post('/logout');

      // Clear all authentication data
      localStorage.removeItem('authToken');

      // Clear all cookies
      const cookies = document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
      }

      // Clear any other auth-related data
      sessionStorage.clear();

      toast.success("Logged out successfully");

      // Force a hard redirect to ensure all state is cleared
      window.location.href = "/signin";
    } catch (error) {
      // Even if the API call fails, we should still try to clear local data
      localStorage.removeItem('authToken');
      const cookies = document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
      }
      sessionStorage.clear();
      window.location.href = "/signin";
    }
  };

  return (
    <nav className="flex items-center space-x-2">
      <Button
        variant="ghost"
        size="icon"
        onClick={handleLogout}
        title="Logout"
      >
        <LogOut className="h-5 w-5" />
      </Button>
    </nav>
  );
} 